// this file is automatically generated by the build-info generator - nx g @studio/tools:build-info
export const build = {
    branch: 'production',
    commit: 'f3ea2daaa346881ab0c74e71979e214ef5c44537',
    date: 'Mon Jan 15 2024 12:49:52 GMT+0000 (Coordinated Universal Time)',
    version: '1.116.2'
};
